import { PermitsManagementSection } from "interfaces/content";
import { useAppContext } from "providers/App";
import React from "react";
import styled from "styled-components";
import Button from "ui/Button";
import FlexBox from "ui/FlexBox";
import Body from "ui/Text/Body";
import Heading from "ui/Text/Heading";
import { getStringWithLineBreak } from "utils/parse";

interface PermitsManagementProps {
  data: PermitsManagementSection["data"];
}

const PermitsManagement = ({ data }: PermitsManagementProps) => {
  const { content } = useAppContext();

  return (
    <Container id={data.id} className="anchor-offset">
      <div className="content-container">
        <Heading align="center" variant="h2" className="section-title" color="primary">
          {data.title}
        </Heading>
        <Body variant="body4" color="secondary" align="center">
          {getStringWithLineBreak(data.description)}
        </Body>
        {data.data && content?.permitCreationFormUrl && (
          <FlexBox>
            <a
              href={`${process.env.REACT_APP_IPARQUE_DRIVER_URL}${content?.permitCreationFormUrl}`}
            >
              <Button className="mt-lg" variant="outlined">
                {data.data.label}
              </Button>
            </a>
          </FlexBox>
        )}
      </div>
    </Container>
  );
};

export default PermitsManagement;

const Container = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background.primary};
`;
